import React from 'react';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    button: {
        margin: theme.spacing(1),
        fontWeight: 'bold',
        maxWidth: '150px'
    },
})

class ViewIdleButton extends React.Component {
    render() {
        return (
            <Button
                variant="contained"
                color="primary"
                className={this.props.className}
                onClick={this.props.onClick}
            >
                View
            </Button>
        )
    }
}

class ViewLoadButton extends React.Component {
    render() {
        return (
            <Button
                variant="contained"
                color="primary"
                disabled
                className={this.props.className}
            >
                <CircularProgress size={24} />
            </Button>
        )
    }
}

class ClearIdleButton extends React.Component {
    render() {
        return (
            <Button
                variant="contained"
                color="secondary"
                className={this.props.className}
                onClick={this.props.onClick}
            >
                Clear
            </Button>
        )
    }
}

class ClearLoadButton extends React.Component {
    render() {
        return (
            <Button
                variant="contained"
                color="secondary"
                disabled
                className={this.props.className}
            >
                <CircularProgress size={24} />
            </Button>
        )
    }
}

class ButtonComponent extends React.Component {
    render() {
        const { classes } = this.props
        return (
            <React.Fragment>
                {this.props.loading ?
                    <Box pt={4} style={{ textAlign: 'center' }}>
                        <ViewLoadButton className={classes.button} />
                        <ClearLoadButton className={classes.button} />
                    </Box>

                    :

                    <Box pt={4} style={{ textAlign: 'center' }}>
                        <ViewIdleButton className={classes.button}
                            onClick={this.props.action} />
                        <ClearIdleButton className={classes.button}
                            onClick={this.props.action_2} />
                    </Box>
                }
            </React.Fragment>
        )
    }
}

export default withStyles(styles, { withTheme: true })(ButtonComponent);